import { useAuth } from "../hooks/Auth/useAuth";
import AppLoading from "./AppLoading";
import { Navigate, useLocation } from "react-router-dom";

export default function ProtectedRoute({
	children,
}: {
	children: JSX.Element;
}) {
	const { isAuthenticated, isLoading } = useAuth();
	const location = useLocation();

	if (isLoading) {
		return <AppLoading />;
	}

	return isAuthenticated ? (
		children
	) : (
		<Navigate to="/login" state={{ from: location }} replace />
	);
}
